import axios from "axios";
import {getDistinctCountries} from "../Helpers/countries";  

//Actions - aspCentres
export const REQUEST_ASP_LOCATIONS = "REQUEST_ASP_LOCATIONS"
export const RECEIVE_DATA = "RECEIVE_DATA"
export const RECEIVE_COUNTRIES = "RECEIVE_COUNTRIES"

export const requestAspLocations = () => {
    return {
        type: REQUEST_ASP_LOCATIONS
    }
}

export const receiveData = (apiUrl) => async (dispatch, getState) => {
    dispatch(requestAspLocations())
    
    console.log("Will get data from", apiUrl)
    const response = await axios.post(apiUrl, {});

    dispatch({ type: RECEIVE_DATA, payload: response.data })
    dispatch({ type: RECEIVE_COUNTRIES, payload: getDistinctCountries(response.data) })
}

//Actions - aspState
export const SET_FILTER_COUNTRY = "SET_FILTER_COUNTRY"
export const SET_FILTERED_TOTAL_COUNT = "SET_FILTERED_TOTAL_COUNT"

export const setFilterCountry = (country) => {
    return {
        type: SET_FILTER_COUNTRY,
        payload: country
    }
}

export const setFilteredTotalCount = (count) => {
    return {
        type: SET_FILTERED_TOTAL_COUNT,
        payload: count
    }
}

//Actions - Pagination
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE"

export const setCurrentPage = (currentPage) => {
    return {
        type: SET_CURRENT_PAGE,
        payload: currentPage
    }
}
